var $ = require('jquery');
var slick = require('@accessible360/accessible-slick');

module.exports = {
	init: function () {
		// A single testimonial is static content, so only treat lists with more than
		// one testimonial as carousels — the rest stay as plain markup.
		var slider = $('.layout.testimonials .testimonials-list-inner').filter(function () {
			return $(this).find('.main-testimonial').length > 1;
		});
		if (slider.length > 0) {
			// Only number the region labels when a page holds more than one testimonials carousel
			var numberRegions = slider.length > 1;
			for (var i = 0; i < slider.length; i++) {
				var $currentSlider = $(slider[i]);
				var $sliderContainer = $currentSlider.closest('.testimonials-list-inner');
				var $sliderControls = $sliderContainer.parent().find('.slider-controls');
				var regionLabel = numberRegions ? 'Testimonials carousel ' + (i + 1) : 'Testimonials carousel';
				// Determine slides to show based on grid class
				var slidesToShow = 1; // Default

				// Init slider with responsive settings
				$currentSlider.slick({
					dots: true,
					infinite: false,
					arrows: true,
					fade: true,
					speed: 300,
					slidesToShow: slidesToShow,
					slidesToScroll: 1,
					draggable: false,
					swipeToSlide: true,
					touchThreshold: 10,
					appendDots: $sliderControls.find('.slick-dots-wrapper'),
					prevArrow: $sliderControls.find('.slick-prev'),
					nextArrow: $sliderControls.find('.slick-next'),
					regionLabel: regionLabel,
				});

				// Slick puts role="region" on the slider element itself, so move the controls
				// inside it for the region to encapsulate the prev/next buttons and the dots
				$currentSlider.append($sliderControls);
			}
		}
	},
};
